<br><br><br><br>
<a routerLink="/learning" class="back-link">← Training &amp; References</a>
<div class="training-hub">
  <div class="page-header">
    <h1 class="page-title">Training</h1>
    <p class="page-subtitle">Complete each module's content, then pass the quiz to mark it complete.</p>
  </div>

  @if (loading) {
    <div class="loading-container">
      <mat-spinner diameter="48"></mat-spinner>
    </div>
  }

  @if (!loading && modules.length === 0) {
    <div class="empty-state">
      <p>No training modules are available yet.</p>
    </div>
  }

  @if (!loading && modules.length > 0) {
    @for (group of groupedModules; track group.category) {
      <div class="category-section">
        <h2 class="category-heading">{{ group.category }}</h2>
        <div class="module-list">
          @for (item of group.items; track item.module._id) {
            <div class="module-row" (click)="openModule(item.module._id)">
              <div class="module-row-main">
                <div class="module-row-title-line">
                  <span class="module-row-title">{{ item.module.title }}</span>
                  @if (moduleCode(item.module)) {
                    <span class="module-code">{{ moduleCode(item.module) }}</span>
                  }
                  @if (item.module.estimatedMinutes) {
                    <span class="time-badge">~{{ item.module.estimatedMinutes }} min</span>
                  }
                </div>
                @if (item.module.description) {
                  <span class="module-row-desc">{{ item.module.description }}</span>
                }
              </div>
              <div class="module-row-meta">
                <span class="status-badge" [class]="getStatusClass(item.progress)">
                  {{ getStatusLabel(item.progress) }}
                </span>
                @if (item.progress?.latestScore !== null && item.progress?.latestScore !== undefined) {
                  <span class="score-badge">Last quiz score: {{ item.progress!.latestScore }}%</span>
                }
              </div>
            </div>
          }
        </div>
      </div>
    }
  }
</div>
